module.exports = __webpack_public_path__ + "static/media/MY-TAYLORS.611dceed.png";